<template>
  <v-main>
    <AppBar/>
    <v-layout fill-height column>
      <v-container flex-fill fluid>
        <div class="coin">
          <div class="d-flex align-center">
            <img :src="getImage('ic_coin.svg')" class="mr-2">
            <div class="d-flex flex-column">
              <span class="fs-12 mb-1 ">보유 코인</span>
              <span class="fs-16 fw-700 primary--text line-height-1">{{ amountCoin | comma }}</span>
            </div>
          </div>
        </div>
        <div class="mt-6">
          <ul class="coin-list">
            <li class="d-flex justify-space-between align-center mb-5" v-for="(item, index) in goodsList" :key="index">
              <div class="d-flex align-center">
                <div class="image flex-shrink-0">
                  <img :src="$downUrl(item.productImg)">
                </div>
                <div class="d-flex flex-column ml-2 mr-5">
                  <div class="fs-14 mb-2 line-clamp-2 " v-text="item.goodsNm"></div>
                  <span class="fs-16 fw-700">{{ (item.saleAmt - item.dcAmt) + 'C'| comma }}</span>
                </div>
              </div>
              <v-btn plain class="btn-exchange" @click="moveExchangeDetail(item.goodsNo, index)" :style="item.btnColor">
                {{ item.exchangeBtnTxt }}
              </v-btn>
            </li>
          </ul>
        </div>
      </v-container>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import moment from "moment";

moment.locale("ko");

export default {
  data: () => ({
    period: 1,
    amountCoin: 0,
    goodsList: null,
    periodValue: ['전체', '1개월', '3개월', '6개월'],
    isSale: true,
    isDisabled: false,
    exchangeBtnTxt: '',
    btnColor: ''
  }),
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  created() {
    this.exchangeDetail();
  },
  methods: {
    async exchangeDetail() {
      await store.dispatch('exchangeDetail', this.$_payload({}))
        .then(res => {
          this.amountCoin = res.data.amountCoin + 'C';
          this.goodsList = res.data.pdGoodsList;
          for (let i = 0; i < this.goodsList.length; i++) {
            if (this.goodsList[i].atchNoList != null) {
              this.goodsList[i].productImg = this.goodsList[i].atchFileNameLists[0];
            }

            if (Number(res.data.amountCoin) < this.goodsList[i].saleAmt) {
              this.goodsList[i].isDisabled = true;
              this.goodsList[i].exchangeBtnTxt = "교환불가";
              this.goodsList[i].btnColor = "background-color:darkgray;"
            } else {
              this.goodsList[i].isDisabled = false;
              this.goodsList[i].exchangeBtnTxt = "교환가능";
              this.goodsList[i].btnColor = ""
            }

          }
        })
        .catch(error => {
          console.error(error)

        })
        .finally(() => {

        })
    },
    async moveExchangeDetail(goodsNo, index) {
      await store.dispatch('exchangeDetail', this.$_payload({}))
        .then(() => {
          if (this.goodsList[index].cntLimit !== 0 && this.goodsList[index].cntLimit === this.goodsList[index].saleCnt) {
            this.$alert("상품 재고가 없습니다.")
          } else {
            this.$router.push(`/fo/coin/exchangeDetails?goodsNo=${goodsNo}`)
          }
        })
        .catch(error => {
          console.error(error)

        })
        .finally(() => {

        })

    }

  }
}
</script>
<style lang="scss" scoped>
.coin {
  background: #F4F4F4;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fs-12.mb-1 {
    color: #909090;
  }
}

.coin-list {
  .image {
    width: 88px;
    height: 88px;
    border-radius: 4px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .btn-exchange {
    background: $color-main;
    border-radius: 20px;
    color: #fff;
    font-size: 12px;
    height: 30px;
    padding: 0 12px;

    &:disabled {
      background: $color-gray-3;
      color: $sub-title;
    }
  }
}

</style>
